import { months } from '../content/calendar';

function EventEntry({ text }: { text: string }) {
  const newlineIdx = text.indexOf('\n');
  if (newlineIdx === -1) {
    // Single-line entry — may have "LOCATION - Short note" pattern
    const dashIdx = text.indexOf(' - ');
    if (dashIdx !== -1) {
      const location = text.slice(0, dashIdx);
      const note = text.slice(dashIdx + 3);
      return (
        <div style={{ borderLeft: '2px solid var(--terracotta)', paddingLeft: 14 }}>
          <div className="mono olive" style={{ marginBottom: 4, fontSize: 10 }}>{location}</div>
          <p style={{ margin: 0, fontSize: 14, color: 'var(--ink-soft)', lineHeight: 1.6 }}>{note}</p>
        </div>
      );
    }
    return (
      <p style={{ margin: 0, fontSize: 14, color: 'var(--ink-soft)', lineHeight: 1.6 }}>{text}</p>
    );
  }

  // Multi-line: first line is "LOCATION - EVENT NAME (date)", rest is description
  const firstLine = text.slice(0, newlineIdx);
  const body = text.slice(newlineIdx + 1).trim();
  const dashIdx = firstLine.indexOf(' - ');
  const location = dashIdx !== -1 ? firstLine.slice(0, dashIdx) : '';
  const eventName = dashIdx !== -1 ? firstLine.slice(dashIdx + 3) : firstLine;

  return (
    <div style={{ borderLeft: '2px solid var(--terracotta)', paddingLeft: 14 }}>
      {location && (
        <div className="mono olive" style={{ marginBottom: 4, fontSize: 10 }}>{location}</div>
      )}
      <div className="display-italic" style={{ fontSize: 17, marginBottom: 8, lineHeight: 1.2 }}>
        {eventName}
      </div>
      <p style={{ margin: 0, fontSize: 13.5, color: 'var(--ink-soft)', lineHeight: 1.65 }}>{body}</p>
    </div>
  );
}

const Calendar = () => {
  return (
    <div>
      {/* HERO */}
      <div className="shell">
        <section className="hero" style={{ gridTemplateColumns: '1fr', paddingBottom: 40 }}>
          <div style={{ maxWidth: 900 }}>
            <span className="eyebrow">Kalendarium · rok w willi</span>
            <h1 className="display hero-headline" style={{ fontSize: 'clamp(48px, 6vw, 96px)' }}>
              Dwanaście miesięcy,<br /><em>dwanaście</em> Toskanii.
            </h1>
            <p className="hero-lede" style={{ maxWidth: 720 }}>
              Każdy miesiąc przynosi inne kolory, zapachy i atrakcje. W zimie narty, latem basen,
              jesienią winobranie — Toskania nie ma złej pory roku.
            </p>
          </div>
        </section>
      </div>

      {/* MONTHS STRIP */}
      <div className="shell">
        <section style={{ padding: '20px 0 60px' }}>
          <div
            style={{
              display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 0,
              borderTop: '1px solid var(--ink)', paddingTop: 14
            }}
            className="months-strip"
          >
            {months.map((m, i) => (
              <div key={m.name} style={{
                borderRight: (i + 1) % 6 !== 0 ? '1px solid var(--line)' : 'none',
                paddingRight: 12, paddingLeft: i % 6 !== 0 ? 12 : 0,
                paddingBottom: 12,
                borderBottom: i < 6 ? '1px solid var(--line)' : 'none',
                paddingTop: i >= 6 ? 12 : 0,
              }}>
                <div className="mono olive">{String(i + 1).padStart(2, '0')}</div>
                <div className="display" style={{ fontSize: 20, marginTop: 4 }}>{m.name}</div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* MONTH NOTES */}
      <div style={{ background: 'var(--cream-2)' }}>
        <div className="shell">
          <section className="section">
            <div className="section-head">
              <div>
                <span className="eyebrow">Rok w willi</span>
                <h2 className="display section-title">Notatki <em>z miesięcy</em>.</h2>
              </div>
              <p className="section-lede">
                Atrakcje i wydarzenia w regionie, miesiąc po miesiącu.
              </p>
            </div>
            <div
              style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }}
              className="months-grid"
            >
              {months.map((m, i) => (
                <div key={m.name} style={{ borderTop: '1px solid var(--ink)', paddingTop: 18 }}>
                  <div className="mono olive" style={{ marginBottom: 8 }}>
                    {String(i + 1).padStart(2, '0')} / 12
                  </div>
                  <div className="display" style={{ fontSize: 30, marginBottom: 20 }}>{m.name}</div>

                  {m.text && m.text.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                      {m.text.map((t, j) => (
                        <EventEntry key={j} text={t} />
                      ))}
                    </div>
                  ) : (
                    <p style={{ margin: 0, fontSize: 13.5, color: 'var(--stone)', lineHeight: 1.6, fontStyle: 'italic' }}>
                      Spokojny miesiąc — willa i okolica zapraszają do odpoczynku.
                    </p>
                  )}
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
